import {useSelector} from 'react-redux';

import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';
import useDeviceSettingContent from '@/containers/DevicesPage/components/DeviceSettings/hooks/useDeviceSettingContent';
import {selectLedIntensity} from '@/state/selectors/deviceSettings';

import {getPopupValueByIntensity} from './illuminationModeUtils';

export const useIlluminationModeContent = () => {
    const content = useDeviceSettingContent(AEM_DEVICE_SETTINGS_TYPES.ILLUMINATION_MODE);
    const deviceLedIntensity = useSelector(selectLedIntensity);

    if (!content) return null;

    const {title, values, notifications, popup, type} = content;

    const currentValue = values?.find((value) => value.value === deviceLedIntensity) || values?.[0];
    const popupCurrentValue = getPopupValueByIntensity(popup, deviceLedIntensity);

    return {
        title,
        currentValue,
        values,
        notifications,
        popup,
        popupCurrentValue,
        type,
    };
};
